import React, { useState } from 'react';
import { downloadCertificate } from '../api/studentApi'; // Path to your API helper
import './CertificateActions.css';

const CertificateActions = ({ attemptId, percentage }) => {
  const [isDownloading, setIsDownloading] = useState(false);
  const [isSharing, setIsSharing] = useState(false);

  // Helper to fetch the certificate Blob from API
  const fetchBlob = async () => {
    const response = await downloadCertificate(attemptId);
    return new Blob([response.data], { type: 'image/png' });
  };

  // Download Handler
  const handleDownload = async () => {
    try {
      setIsDownloading(true);
      const blob = await fetchBlob();
      
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `KnolUp_Certificate_${attemptId}.png`);
      
      document.body.appendChild(link);
      link.click();
      
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error downloading certificate:', error);
      alert('Failed to download certificate. Please try again.');
    } finally {
      setIsDownloading(false);
    }
  };

  // Share Handler
  const handleShare = async () => {
    try {
      setIsSharing(true);
      const blob = await fetchBlob();
      const file = new File([blob], `KnolUp_Certificate_${attemptId}.png`, { type: 'image/png' });

      // Web Share API support (Mobile / Supported desktop browsers)
      if (navigator.canShare && navigator.canShare({ files: [file] })) {
        await navigator.share({
          title: 'KnolUp Certificate',
          text: `Check out my certificate for scoring ${percentage}% on KnolUp!`,
          files: [file],
        });
      } else {
        // Fallback: Copy link to clipboard
        const certUrl = `${window.location.origin}/api/quizzes/quiz/certificate/${attemptId}`;
        await navigator.clipboard.writeText(certUrl);
        alert('Certificate URL copied to clipboard!');
      }
    } catch (error) {
      if (error.name !== 'AbortError') {
        console.error('Error sharing certificate:', error);
      }
    } finally {
      setIsSharing(false);
    }
  };

  // Do not render actions if percentage is 80% or below
  if (percentage <= 80) {
    return (
      <div className="cert-locked-notice">
        Certificates are unlocked for scores above 80%. Keep practicing!
      </div>
    );
  }

  return (
    <div className="cert-actions-container">
      {/* Download Button */}
      <button
        onClick={handleDownload}
        disabled={isDownloading}
        className="cert-btn cert-btn-primary"
      >
        <svg className="cert-btn-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
        </svg>
        <span>{isDownloading ? 'Downloading...' : 'Download Certificate'}</span>
      </button>

      {/* Share Button */}
      <button
        onClick={handleShare}
        disabled={isSharing}
        className="cert-btn cert-btn-secondary"
      >
        <svg className="cert-btn-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z" />
        </svg>
        <span>{isSharing ? 'Preparing...' : 'Share Certificate'}</span>
      </button>
    </div>
  );
};

export default CertificateActions;